/**
 * Immediately removes the spinner from the DOM and posts a message to parent window
 */
export function removeWaitSpinnerImmediate(): void {
  const spinner = document.getElementById("spinner");
  if (spinner != null && spinner.parentElement != null) {
    spinner.parentElement.removeChild(spinner);
  }
  window.parent.postMessage("finished", "*");
}

/**
 * Starts the fade-out animation for the spinner, then removes it from DOM after the transition
 */
export function removeWaitSpinner(): void {
  const spinner = document.getElementById("spinner");
  if (spinner != null) {
    spinner.classList.add("close");
    setTimeout(removeWaitSpinnerImmediate, 1000);
  }
}

/**
 * Shows the spinner by creating and adding it to the DOM if it doesn't exist
 */
export function showWaitSpinner(): void {
  // Check if spinner already exists
  let spinner = document.getElementById("spinner");
  if (spinner != null) {
    // Remove any close class and make sure it's visible
    spinner.classList.remove("close");
    return;
  }

  // Create new spinner element
  spinner = createSpinnerElement();
  document.body.appendChild(spinner);
}

/**
 * Creates and returns the spinner HTML element
 *
 * @returns The spinner DOM element
 */
export function createSpinnerElement(): HTMLElement {
  const spinner = document.createElement("div");
  spinner.id = "spinner";

  const grid = document.createElement("div");
  grid.className = "spinner-grid";

  for (let i = 1; i <= 9; i++) {
    const square = document.createElement("div");
    square.className = `square square${i}`;
    grid.appendChild(square);
  }

  spinner.appendChild(grid);
  return spinner;
}
